/**
 * CustomConviteInstalar — a faixa que aparece para quem usa o app pelo navegador.
 *
 * CELULAR E COMPUTADOR. Instalar vale nos dois: no celular vira ícone na tela
 * inicial; no computador vira janela própria, sem a barra do navegador. A
 * diferença é o que se pode oferecer:
 *
 *   - se o Chrome já entregou o convite (`temPrompt`), a faixa instala NA HORA,
 *     em um clique — não há por que mandar a pessoa para outra tela;
 *   - se não entregou (iPhone sempre; Firefox; Chrome que já ofereceu antes), o
 *     botão leva para /public/instalar, que explica o caminho daquele aparelho.
 *
 * No computador, sem convite do Chrome e sem passo a passo útil a dar, a faixa
 * não aparece: um aviso que não leva a lugar nenhum é só ruído.
 *
 * QUEM JÁ INSTALOU NÃO VÊ NADA — e a checagem é `display-mode: standalone`, não
 * uma marca no navegador: a pessoa pode ter instalado no celular e estar aqui
 * pelo computador, e o convite estaria errado nos dois sentidos.
 *
 * DISPENSÁVEL, E A DISPENSA DURA. Guardada em `localStorage`: uma faixa que
 * volta toda vez deixa de ser convite e vira estorvo — e a pessoa aprende a
 * ignorar a região da tela onde ela aparece, que é justo onde ficam os avisos
 * que importam.
 *
 * Portado do projeto irmão `webapp-rm-ops` (08/08/2026).
 */
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { instalarAgora } from '@/lib/instalacao';
import { usarInstalacao } from '@/lib/usar-instalacao';

const CHAVE = 'caa_ops_convite_instalar_dispensado';

export function CustomConviteInstalar() {
  const { ambiente, temPrompt } = usarInstalacao();
  const [dispensado, setDispensado] = useState(() => !!localStorage.getItem(CHAVE));
  const [instalando, setInstalando] = useState(false);
  const [pronto, setPronto] = useState(false);

  if (!ambiente || dispensado || pronto) return null;
  if (ambiente.instalado) return null;

  const noCelular = ambiente.aparelho === 'android' || ambiente.aparelho === 'ios';
  if (!noCelular && !temPrompt) return null;

  async function instalar() {
    setInstalando(true);
    const ok = await instalarAgora();
    setInstalando(false);
    if (ok) setPronto(true);
  }

  return (
    <div className="alert alert-theme-1 d-flex align-items-center gap-2 py-2 mb-3">
      <i className={`bi ${noCelular ? 'bi-phone' : 'bi-window-desktop'} fs-5`}></i>
      <div className="flex-grow-1 small lh-sm">
        <strong>Instale o app</strong>
        <div className="text-secondary">
          {noCelular
            ? 'Fica um ícone na tela do celular.'
            : 'Abre em janela própria, sem a barra do navegador.'}
        </div>
      </div>
      {temPrompt ? (
        <button
          type="button"
          className="btn btn-sm btn-theme"
          onClick={instalar}
          disabled={instalando}
        >
          {instalando ? 'Instalando…' : 'Instalar'}
        </button>
      ) : (
        <Link className="btn btn-sm btn-theme" to="/public/instalar">
          Ver como
        </Link>
      )}
      <button
        type="button"
        className="btn btn-link btn-square text-secondary"
        aria-label="Dispensar"
        onClick={() => {
          localStorage.setItem(CHAVE, '1');
          setDispensado(true);
        }}
      >
        <i className="bi bi-x-lg"></i>
      </button>
    </div>
  );
}
